import React, { useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useDispatch, useSelector } from "react-redux";
import HeaderLogo from "../../images/cashbach/colombialogo.png";
import UserIcon from "../../images/cashbach/Vector-user.svg";
import { useHistory } from "react-router-dom";
import Login from "../Login/Login";
const Layout = (props) => {
  const localDataVal = localStorage.getItem("user");
  const userDataVal = localDataVal != null ? JSON.parse(localDataVal) : {};
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".user-dropdown")) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUserData(null);
    setDropdownVisible(!dropdownVisible);
    history.push("/Login");
  };

  // useEffect(() => {
  //   const savedData = localStorage.getItem("user");
  //   if (savedData) {
  //     const userData = JSON.parse(savedData);
  //     if (userDataVal?.id) {
  //       setUserData(userDataVal);
  //     }
  //   }
  // }, []);
  const history = useHistory();
  const [userData, setUserData] = useState(userDataVal);
  // const [name,setName] = useState("clay");
  const [phoneNumber, setPhoneNumber] = useState("1003482264");
  const handleLogin = () => {
    // Add your login logic here
    if (phoneNumber) {
      history.push("/home");
      const userObj = { phoneNumber, id: "1" };
      setUserData(userObj);
      localStorage.setItem("user", JSON.stringify(userObj));
    } else {
      alert("Please enter valid name and phoneNumber");
    }
  };

  return (
    <div className={"wrapper-hide-header"}>
      <div className="top-header">
        <div className="logo-section">
          <img
            src={HeaderLogo}
            alt="HeaderLogo"
            onClick={() => {
              history.push("/");
            }}
          />
        </div>
        <div className="account-section">
          {true && (
            <div className="user-dropdown">
              <img
                src={UserIcon}
                alt="UserIcon"
                className="user-icon"
              />
              {dropdownVisible && (
                <div className="user-dropdown-menu">
                  <div
                    className="dropdown-item"
                    onClick={() => history.push("/myearnings")}
                  >
                    My Earnings
                  </div>
                  <div className="dropdown-item" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {true ? (
        <>
          <hr />
          <Header />
          <div className="layout-container full-content-sec-page-design1">
            <div className="my-account-sec-bottom">
              <div className="right-menu-side-content1"> {props.children}</div>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <>
          <Login
           // name={name}
            phoneNumber={phoneNumber}
           // setName={setName}
            setPhoneNumber={setPhoneNumber}
            handleLogin={handleLogin}
          />
        </>
      )}
    </div>
  );
};

export default Layout;
